// extracted by mini-css-extract-plugin
module.exports = {"ModalContainer":"style_ModalContainer__2hdQX","CloseBtn":"style_CloseBtn__2lDl4","Body":"style_Body__3umaA","ModalTitle":"style_ModalTitle__1_lSD","RowText":"style_RowText__AKr9K"};